import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5292f2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline-block" }
const _hoisted_2 = {
  key: 0,
  class: "text-red-500 ml-auto flex place-items-center"
}
const _hoisted_3 = { class: "inline-block relative w-full" }
const _hoisted_4 = { class: "flex gap-1 flex-1 items-center max-w-full" }
const _hoisted_5 = { class: "truncate" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "text-center p-4"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No hay elementos en la lista", -1))
const _hoisted_10 = [
  _hoisted_9
]

import { computed, watch, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectorSimpler',
  props: {
  selected: {
    type: [Number, String, Object],
    required: false,
  },
  placeholder: {
    type: String,
  },
  errorMessage: {
    type: String,
    default: "",
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  items: {
    type: Array,
    required: false,
  },
  label: {
    type: String,
    required: false,
  },
},
  emits: ["update:model"],
  setup(__props, { emit }) {

const props = __props;





const items = computed(() => props.items ?? []);

const selectedItem = computed(() => {
  if (typeof props.selected == "string" || typeof props.selected == "number") {
    return items.value?.find((item) => item.key && item?.key == props.selected);
  }

  if (typeof props.selected == "object") {
    return items.value?.find(
      (item) => item.key && item?.key == props.selected?.key
    );
  }

  return null;
});

const isActive = ref<boolean>(false);

const select = (item: object | unknown) => {
  isActive.value = false;
  emit("update:model", item);
};

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_Popper = _resolveComponent("Popper")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(["flex text-sm font-semibold pb-1", { 'text-red-500': __props.hasError, 'text-gray-700': !__props.hasError }])
        }, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.hasError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_Popper, {
                  arrow: "",
                  class: "font-normal",
                  placement: "auto",
                  hover: "",
                  content: __props.errorMessage
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_mdicon, {
                      name: "error",
                      size: "16"
                    })
                  ]),
                  _: 1
                }, 8, ["content"])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = () => (isActive.value = !isActive.value)),
        class: _normalizeClass(["appearance-none border rounded-sm w-full py-1 px-2 leading-tight focus:outline-none cursor-pointer flex items-center h-[38px] relative select-none bg-white", {
          'text-gray-700 border-gray-300 focus:border-black hover:border-gray-400':
            !__props.hasError,
          'text-red-700 border-red-300 focus:border-red-800 hover:border-red-400':
            __props.hasError,
        }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(selectedItem.value ? selectedItem.value?.value : __props.placeholder), 1)
        ]),
        _createVNode(_component_mdicon, {
          class: "absolute right-2 bg-white",
          name: "chevron-down",
          size: "20"
        })
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([{
          block: isActive.value,
          hidden: !isActive.value,
        }, "absolute text-gray-700 bg-white left-0 w-full min-w-max border-gray-200 border-[0.5px] shadow-lg overflow-y-auto max-h-36 z-50 select-none"])
      }, [
        (items.value && items.value?.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, key) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: key,
                  class: _normalizeClass([
              selectedItem.value?.key == item?.key ? 'font-bold' : '',
              'hover:bg-primary-50 active:bg-primary-100 py-2 px-4 block whitespace-no-wrap cursor-pointer',
            ]),
                  onClick: ($event: any) => (select(item))
                }, _toDisplayString(item.value ?? "-"), 11, _hoisted_7))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      ], 2)
    ])), [
      [_directive_click_outside, () => (isActive.value = false)]
    ])
  ]))
}
}

})